import { render, staticRenderFns } from "./personalMotor.vue?vue&type=template&id=3980d0ea&"
import script from "./personalMotor.vue?vue&type=script&lang=ts&"
export * from "./personalMotor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports